export const variants = {
  hidden: { zIndex: 0, opacity: 0, y: 0 },

  showIsBack: { opacity: [1, 1], zIndex: 10, y: [0, 0] },
  closedIsBack: { y: [0, 80], opacity: 0, zIndex: 11 },

  showIsForward: { opacity: [0, 1], zIndex: 11, y: [80, 0] },
  closedIsForward: { y: 0, opacity: [1, 0], zIndex: 10 }
};
